// @lib-generic-ui
export const EXTERNAL_ID_TYPE = "external_id";
export const INT_TYPE = "int";
export const NUMBER_TYPE = "number";
export const STRING_TYPE = "stirng";
export const TIMESTAMP_TYPE = "timestamp";
export const IMAGE_TYPE = "image";
export const AVATAR_TYPE = "avatar";
export const STRING_OPTIONS_TYPE = "string_options";
export const BOOLEAN_TYPE = "boolean";
export const SLUG_TYPE = "slug";